import event, {EVENTS} from './event';
import AudioContext from '../../lib/audio/shared-audio-context';

const EventAudios = {
    "ui": "start-drag",
    "endDrag": "end-drag",
    "change": "change"
};

let timer = null

for (let type in EventAudios) {
    (type=>{
        event.on(type, ()=>{
            Audio.play(`${window.config.staticURL}/audio/${EventAudios[type]}.mp3`);
        });
    })(type);
}

class Audio {
    static getAudioCtx() {
        if (Audio.audioCtx !== undefined && Audio.audioCtx.decodeAudioData !== undefined) {
            return Audio.audioCtx;
        } else {
            Audio.audioCtx = new AudioContext();
            if (Audio.audioCtx.decodeAudioData === undefined) {
                return undefined;
            }else {
                return Audio.audioCtx;
            }
        }
    }
    static getBuffer(src) {
        return new Promise((resolve, reject)=>{
            if (Audio.cache[src]) {
                resolve(Audio.cache[src]);
                return;
            }
            const audioCtx = Audio.getAudioCtx();
            if (audioCtx) {
                let request = new XMLHttpRequest();
                request.open("GET", src, true);
                request.responseType = "arraybuffer";
                request.onload = function() {
                    audioCtx.decodeAudioData(request.response, buffer => {
                        Audio.cache[src] = buffer;
                        resolve(buffer);
                    }, e => {
                        reject(e);
                    });
                };
                request.send();
            }else {
                reject('not support audioCtx');
                // window.stopSpeak();
                setTimeout(()=>{
                    window.stopSpeak(2);
                },100)
            }
        })
    }

    static createSound(buffer) {
        /*
        if (audioCtx.state == 'suspended') {
            audioCtx.resume();
        }
        */

        if (Audio.source) {
            Audio.stop();
        }
        const audioCtx = Audio.getAudioCtx();
        if (audioCtx === undefined) return undefined;
        Audio.source = audioCtx.createBufferSource();
        Audio.source.buffer = buffer;
        Audio.source.connect(audioCtx.destination);
        if (audioCtx.state == 'suspended' || audioCtx.state == 'interrupted') {
            audioCtx.resume();
        }
        return Audio.source;
    }

    static stop() {
        try {
            if (Audio.source) {
                try {
                    Audio.source.stop();
                }catch(e) {
                    console.error(e);
                }

                try {
                    Audio.source.disconnect();
                }catch(e) {
                    console.error(e)
                }

                Audio.source = undefined;
            }
        }catch(e) {
            console.error(e);
        }
    }
    static play(src, getSource) {
        clearTimeout(timer)
        Audio.getBuffer(src).then(buf=>{
            if (Audio.createSound(buf)) {
                Audio.source.start();
                timer = setTimeout(()=>{
                    window.stopSpeak()
                },buf.duration*1000)
                if (typeof getSource == 'function') getSource(Audio.source);
            }else {
                console.error('create sound fail');
            }
        })
    }

    static tts(text, getSource) {
        if (Audio.lastText === text && Date.now() - Audio.lastTtsTime < 1000) return; //避免重复播放
        if (!text) {
            console.error("tts text empty");
            return;
        }
        Audio.lastText = text;
        Audio.lastTtsTime = Date.now();
        Audio.play(window.config.apiBaseURL + "/speech/tts.mp3?t=" + encodeURIComponent(text), getSource);
    }
}

Audio.audioCtx = undefined;
Audio.cache = new Map();
Audio.source = undefined;
Audio.lastText = '';
Audio.lastTtsTime = 0;
window.MyAudio = Audio;

export default Audio;
